<template>
  <div class="full-height d--f fd--c ai--c jc--c">
    <h1>Page Not Found</h1>
    <p class="text-muted mt-10px">The page you are looking for does not exist.</p>
    <router-link class="router-button mt-20px" to="/">Go to Home</router-link>
  </div>
</template>

<script setup>
</script>
